import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTenantStore = defineStore('tenantStore', () => {
  const selectedTenantId = ref<string | undefined>(undefined);

  const saved = localStorage.getItem('SELECTED_TENANT_ID');
  if (saved) {
    selectedTenantId.value = saved;
  }

  function setSelectedTenant(tenantId: string) {
    selectedTenantId.value = tenantId;
    localStorage.setItem('SELECTED_TENANT_ID', tenantId);
  }

  function removeSelectedTenant() {
    localStorage.removeItem('SELECTED_TENANT_ID');
    selectedTenantId.value = undefined;
  }

  return {
    selectedTenantId,
    setSelectedTenant,
    removeSelectedTenant,
  };
});
